import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-plaid-error-alert',
  templateUrl: './plaid-error-alert.component.html',
  styleUrls: ['./plaid-error-alert.component.scss']
})
export class PlaidErrorAlertComponent {
  @Output() retry = new EventEmitter<void>();
  @Output() manualEntry = new EventEmitter<void>();

  onRetry(): void {
    this.retry.emit();
  }

  onManualEntry(): void {
    this.manualEntry.emit();
  }
}
